var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"content-wrapper"}},[(Object.keys(_vm.translations).length > 0)?[_c('portal-target',{attrs:{"name":"modal","slim":""}}),_c('router-view'),_c('toaster')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }